import moment, {Moment} from 'moment';

const momentPool = new Map<string, Moment>();

export function getPooledMoment(dayString: string | Date | number, format?: string) {
  const key = `${dayString}|${format || ''}`;
  if (!momentPool.has(key)) {
    momentPool.set(key, moment(dayString, format));
  }

  return momentPool.get(key) as Moment;
}

export const parseDateTime = (date, time, setToEndofMinute = false) => {
  const parsedDate = moment(date).format('YYYY-MM-DD');
  const parsedTime = moment(time || '0', 'LT').format('HH:mm:ss');


  if (setToEndofMinute) {
    return moment(`${parsedDate} ${parsedTime}`, 'YYYY-MM-DD HH:mm:ss')
      .endOf('minute')
      .toDate()
      .toISOString();
  }
  return moment(`${parsedDate} ${parsedTime}`, 'YYYY-MM-DD HH:mm:ss').toDate().toISOString();
};
